import React, { FC } from "react";

interface CompleteIconProps {}

const CompleteIcon: FC<CompleteIconProps> = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      viewBox="0 0 24 24"
      fill="none"
      width="16"
      className="QontoStepIcon-completedIcon"
    >
      <path
        d="M20.25 6.75047L9.75 17.25L4.5 12.0005"
        stroke="currentcolor"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </svg>
  );
};

export default CompleteIcon;
